import { Text } from "@meditect/medibase-components";

export const SalesCannotSaleArchivedPharmacyProductError = () => {
  return (
    <Text>
      Certains produits présents dans la vente ont déjà été archivés. Veuillez supprimer ces produits ou les désarchiver
      puis recharger les produits dans le panier.
    </Text>
  );
};
